/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/users/password-resets",
    },
    (router) => {
      router.push({
        id: "@api/passwordReset@create",
        path: "",
      });

      router.push({
        id: "@api/passwordReset@complete",
        path: "/action/complete",
      });
    },
  );
}
